import { Injectable, computed, effect, signal } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { LoadingKeys } from './loading-constants';
import { QuestionaryNames } from 'src/app/features/medical-record/model/questionnaire-response';
import _ from 'lodash';
import { HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export type LoadingState = Partial<Record<LoadingKeys, boolean>>


const createKeyFromReq = (req: HttpRequest<any>) => {
  const endpoint = req.url.split(environment.datastore).pop();
  const method = req.method;
  const params = req.params.toString()

  return `${method}$${endpoint}$${params}`
}

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  private loadingHash: { [id: string]: number };
  constructor() {
    this.loadingHash = {};
  }
  private loadingStatesLegado$: BehaviorSubject<LoadingState> =
    new BehaviorSubject<LoadingState>({});

  private _loadingState = signal<LoadingState>({})

  // dicionario baseado apenas em ${metodo}*${endpoint}
  private _automaticLoadingState = signal<Record<string, boolean>>({})

  startLoadingAutoKey({ req }: { req: HttpRequest<any> }) {
    const key = createKeyFromReq(req)
    this._automaticLoadingState.update(obj => ({
      ...obj,
      [key]: true
    }))
  }

  finisgLoadingAutoKey({ req }: { req: HttpRequest<any> }) {
    const key = createKeyFromReq(req)
    this._automaticLoadingState.update(obj => ({
      ...obj,
      [key]: false
    }))
  }

  startLoading(key: LoadingKeys) {
    this._loadingState.update(obj => ({
      ...obj,
      [key]: true
    }))
  }

  finishLoading(key: LoadingKeys) {
    this._loadingState.update(obj => ({
      ...obj,
      [key]: false
    }))
  }

  isKeyLoading(key: LoadingKeys) {
    return !!this._loadingState()[key]
  }

  get loadingState() {
    return this._loadingState.asReadonly()
  }

  get autoLoadingState() {
    return this._automaticLoadingState.asReadonly()
  }

  isLoadingLeg(identifier: LoadingKeys): Observable<boolean> {
    return this.loadingStatesLegado$
      .asObservable()
      .pipe(
        map((loadingStates: LoadingState) => loadingStates[identifier] || false)
      );
  }

  show(identifier: LoadingKeys): void {
    const loadingStates = this.loadingStatesLegado$.value;
    loadingStates[identifier] = true;
    this.loadingStatesLegado$.next(loadingStates);
  }

  hide(identifier: LoadingKeys): void {
    const loadingStates = this.loadingStatesLegado$.value;
    loadingStates[identifier] = false;
    this.loadingStatesLegado$.next(loadingStates);
  }

  initializeLoading(uid: string, value: number) {
    this.loadingHash[uid] = value;
  }

  finalizeLoading(uid: string, force?: boolean) {
    if (force === undefined || force === null || !force) {
      this.loadingHash[uid]--;
    } else {
      this.loadingHash[uid] = 0;
    }
  }
}
